import { render, staticRenderFns } from "./a-dui-tab-options.vue?vue&type=template&id=768c9364&scoped=true&"
import script from "./a-dui-tab-options.vue?vue&type=script&lang=js&"
export * from "./a-dui-tab-options.vue?vue&type=script&lang=js&"
import style0 from "./a-dui-tab-options.vue?vue&type=style&index=0&id=768c9364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c9364",
  null
  
)

export default component.exports